var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import SelectContainer from './SelectContainer';
var Select = forwardRef(function (_a, ref) {
  var _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      icon = _a.icon,
      _a$status = _a.status,
      status = _a$status === void 0 ? 'default' : _a$status,
      children = _a.children,
      className = _a.className,
      rest = __rest(_a, ["disabled", "icon", "status", "children", "className"]);

  var selectRef = useRef(null);
  useImperativeHandle(ref, function () {
    return selectRef.current;
  });
  return _jsx(SelectContainer, Object.assign({
    className: className,
    icon: icon,
    disabled: disabled,
    status: status
  }, {
    children: _jsx("select", Object.assign({
      ref: selectRef,
      disabled: disabled
    }, rest, {
      children: children
    }), void 0)
  }), void 0);
});
export default Select;